import script from "./addMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./addMenu.vue?vue&type=script&setup=true&lang=js"

import "./addMenu.vue?vue&type=style&index=0&id=bd7c275c&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd7c275c"]])

export default __exports__